import { boot } from 'quasar/wrappers'
import removeUrlSignature from '../functions/remove-url-signature'

export default boot(({ app }) => {
	app.config.globalProperties.$removeUrlSignature = removeUrlSignature
})
